import { supabase } from "@/integrations/supabase/client";

const VIEW_TTL_MS = 30 * 60 * 1000; // 30 min per session per property
const CLICK_TTL_MS = 5 * 60 * 1000; // 5 min per session per property

function shouldThrottle(key: string, ttl: number): boolean {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw) {
      const ts = parseInt(raw, 10);
      if (!isNaN(ts) && Date.now() - ts < ttl) return true;
    }
    sessionStorage.setItem(key, String(Date.now()));
  } catch {}
  return false;
}

async function getUserId(): Promise<string | null> {
  try {
    const { data } = await supabase.auth.getUser();
    return data.user?.id ?? null;
  } catch {
    return null;
  }
}

export function trackPropertyView(propertyId: string, source: string = "detail") {
  if (!propertyId) return;
  if (shouldThrottle(`pv:${propertyId}`, VIEW_TTL_MS)) return;
  // Skip if owner is the host viewing their own listing
  (async () => {
    try {
      const userId = await getUserId();
      await (supabase as any).from("property_views").insert({
        property_id: propertyId,
        viewer_user_id: userId,
        source,
      });
    } catch {}
  })();
}

export function trackPropertyClick(propertyId: string, source: string = "card") {
  if (!propertyId) return;
  if (shouldThrottle(`pc:${propertyId}`, CLICK_TTL_MS)) return;
  (async () => {
    try {
      const userId = await getUserId();
      await (supabase as any).from("property_clicks").insert({
        property_id: propertyId,
        viewer_user_id: userId,
        source,
      });
    } catch {}
  })();
}
